import { Helmet } from 'react-helmet';
import { useQueryData, usePostMessage } from 'spectacle-ui-game-bridge-react';
import VideoPlayer from '../../components/videoPlayer/videoPlayer';
import { useParams, useSearchParams } from 'react-router-dom';
import './video.sass';
import useDlogLoginFunnel, { LoginFunnelAction, LoginFunnelTargets } from '../../hooks/useDlogLoginFunnel';
import useDebouncedDlogFunnel from '../../hooks/useDebouncedDlogFunnel';
import useBase64Decoded from '../../hooks/useBase64Decoded';
import CloseIcon from '../../icons/CloseIcon';

export default function Video() {
  const [searchParams] = useSearchParams();
  const { vid } = useParams();
  const videoUrl = useBase64Decoded(vid ?? '');
  const closeWebView = usePostMessage('closeWebView');
  const [volume] = useQueryData<number>('game', 'master_volume');
  const dlog = useDlogLoginFunnel();
  const dlogVideoPlayed = useDebouncedDlogFunnel({
    phase: 'Video_Player_Active',
    action: 'Video_Started',
    targets: videoUrl as LoginFunnelTargets,
    resume: false,
  });
  const dlogVideoLooped = useDebouncedDlogFunnel({
    phase: 'Video_Player_Active',
    action: 'Video_Started',
    targets: videoUrl as LoginFunnelTargets,
    resume: true,
  });
  const dlogVideoStuttering = useDebouncedDlogFunnel({
    phase: 'Video_Player_Active',
    action: 'Video_Stuttering',
    targets: videoUrl as LoginFunnelTargets,
  });
  const killEffectInfo = searchParams.get('killEffectInfo');

  const closeVideo = (e: any) => {
    e.preventDefault();

    closeWebView();
  };

  return (
    <>
      <Helmet>
        <title>Video</title>
      </Helmet>
      <VideoPlayer
        src={videoUrl}
        poster={searchParams.get('poster')}
        muted={searchParams.get('muted') === 'true'}
        autoPlay={searchParams.get('autoplay') === 'true'}
        loop={searchParams.get('loop') === 'true'}
        volume={volume ? Number(volume) : 1}
        controls={searchParams.get('controls') === 'true'}
        onPlay={(event, looped) => (looped ? dlogVideoLooped() : dlogVideoPlayed())}
        onWaitingFirstTime={dlogVideoStuttering}
        onFinishedFirstPlaythrough={(event, stutterCount) =>
          dlog({
            phase: 'Video_Player_Active',
            action: `Video_Stuttered:${stutterCount}` as LoginFunnelAction,
            targets: videoUrl as LoginFunnelTargets,
          })
        }
      />
      {killEffectInfo && <div className="video__label-text">{killEffectInfo}</div>}
      <button className="close" onClick={closeVideo}>
        <CloseIcon className="external-link__icon" />
      </button>
    </>
  );
}
